<template>
  <ScrollKeyFrame id="Font2022" class="font-project" :nav-list="sectionList">
    <section class="section-1 main-section">
      <div class="scroll-mark"></div>
      <div class="contents-wrapper">
        <div class="type-main-title h1">2023</div>
        <div class="type-main-description">
          <span>가비아 흘돋체 <span class="x-mark hidden collaboration small"></span> 가비아 온담체</span>
        </div>
      </div>
      <video autoplay muted loop playsinline>
        <source src="https://static.gabia.com/fonts/project/video/sub_3.mp4" />
      </video>
    </section>
    <section class="section-2" id="font-info" @mouseenter="autoPlay(true)" @mouseleave="autoPlay(false)">
      <div class="section-contents-wrapper">
        <div class="section-title align-left" data-aos="fade-up" data-aos-duration="1000" data-aos-offset="120">
          <span class="title">제작 의도</span>
        </div>
        <div class="section-contents-project-info"  data-aos="fade-up" data-aos-duration="1000" data-aos-offset="120">
          <div class="project-info-type">
            <div class="type-font-btn" :class="{active_green: setProjectInfo.name === '흘돋체'}" @click="getProjectInfo(0)">가비아 흘돋체</div>
            <div class="type-font-btn" :class="{active_red: setProjectInfo.name === '온담체'}" @click="getProjectInfo(1)">가비아 온담체</div>
          </div>
          <h4 class="project-info-title">{{setProjectInfo.title}}</h4>
          <div class="project-info-description font-24">{{setProjectInfo.description}}</div>
          <div class="project-info-slide-wrapper line-card-wrapper">
            <div class="slide-nav-control" :class="setProjectInfo.name === '흘돋체' ? 'green' : 'red'">
              <span class="prev" @click="movePrev">
                <svg width="50" height="50" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <polygon points="25, 18 16, 32 34, 32" class="arrow arrow-left" transform="rotate(-90, 25, 25)"></polygon>
                </svg>
              </span>
              <div class="nav-text"><span class="current">{{activeId + 1}}</span> / {{setProjectInfo.infoList.length}}</div>
              <span class="next" @click="moveNext">
                <svg width="50" height="50" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <polygon points="25, 18 16, 32 34, 32" class="arrow arrow-left" transform="rotate(90, 25, 25)"></polygon>
                </svg>
              </span>
            </div>
            <div class="slide-wrapper">
              <div class="project-info-item" v-for="(item, index) in setProjectInfo.infoList" :key="index"
                   :class="[{current:index === activeId}, {prev:index === previewIndex}, {next:index === nextIndex}]"
              >
                <div class="project-image">
                  <img :src="`https://static.gabia.com/fonts/project/image/${item.image}`" alt="">
                </div>
                <div class="project-text">
                  {{item.text}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section-2" id="font-1">
      <div class="section-contents-wrapper">
        <div class="section-title align-left">
          <span class="title underline">가비아 흘돋체</span>
          <span class="download-link">
            <a href="https://static.gabia.com/fonts/project/fonts/Download-font/GabiaHeuldot.zip">다운받기 <i class="far fa-arrow-to-bottom"></i></a>
          </span>
        </div>
        <div class="section-description description align-left">
          <p>가비아 흘돋체는 돋움의 골격에 부드러운 흘림을 더한 글꼴입니다. 제목과 본문용으로 두루 활용할 수<br>
            있습니다. 속공간이 넓고, 여유로워 판독성이 뛰어난 것이 특징입니다. 인쇄물과 디지털 화면 모두에서<br>
            선명하게 읽히도록 디자인했습니다.</p>
        </div>
        <FontCharacter base-color="#83EBB8" :character-list="heuldotData.list" :character-info="heuldotData.info">
          <img src="https://static.gabia.com/fonts/project/image/font_characters/heuldot.png">
        </FontCharacter>
      </div>
    </section>
    <section class="section-2" id="font-2">
      <div class="section-contents-wrapper">
        <div class="section-title align-left">
          <span class="title underline">가비아 온담체</span>
          <span class="download-link">
            <a href="https://static.gabia.com/fonts/project/fonts/Download-font/GabiaOndam.zip">다운받기 <i class="far fa-arrow-to-bottom"></i></a>
          </span>
        </div>
        <div class="section-description description align-left">
          <p>가비아 온담체는 손의 움직임을 적용한 민부리 글꼴입니다. 시, 노래의 가사나 영상의 자막으로<br>
            쓰기 적합합니다. 제목∙본문, 인쇄∙화면 모두에 최적화된 글꼴입니다.</p>
        </div>
        <FontCharacter base-color="#FA8BA0" :character-list="ondamData.list" :character-info="ondamData.info">
          <img src="https://static.gabia.com/fonts/project/image/font_characters/ondam.png">
        </FontCharacter>
      </div>
    </section>
    <section class="section-6 section-sample-editor" id="font-sample">
      <div class="section-contents-wrapper">
        <div class="section-title title  align-left">
          <span class="title">써보기</span>
        </div>
        <div class="section-title description"></div>
        <div class="section-contents-editor line-card-wrapper" ref="editor" :class="[theme]">
          <div class="content-editor-wrapper">
            <div class="sample-text-editor" ref="note"
                  spellcheck="false"
                 :contenteditable="contenteditable" :class="[selectedFont]"
                 :placeholder="`가비아 ${selectedFontText}를 사용해 보세요.`"
                 :style="{ fontSize: `${editorValue.fontSize}px`}"
            >
            </div>
          </div>
          <div class="text-editor-control">
            <div class="control-font-family">
              <ButtonControl :button-list="fontList" :active-color="`green`" @select="setFontFamily" />
            </div>
            <div class="control-font-size">
              <SliderControl :min-value="30" :max-value="100" v-model="editorValue.fontSize" @update="setFontSize"/>
            </div>
            <div class="control-theme">
              <ButtonControl :button-list="themeList" :active-color="`purple`" @select="setTheme" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <Footer />
</ScrollKeyFrame>
</template>

<script>
import ScrollKeyFrame from '@/Modules/ScrollKeyFrame/scrollKeyFrame.vue';
import FontCharacter from '@/components/FontCharacter.vue';
import Footer from '@/components/Footer.vue';
import SliderControl from '@/Modules/sliderControl/sliderControl.vue';
import ButtonControl from '@/Modules/sliderControl/buttonControl.vue';

export default {
  name: 'Font2022',
  components: {
    ScrollKeyFrame, FontCharacter, Footer, SliderControl, ButtonControl,
  },
  data() {
    return {
      theme: 'light',
      scrollTop: 0,
      sectionList: [
        { title: '제작 의도', target: '#font-info' },
        { title: '가비아 흘돋체', target: '#font-1' },
        { title: '가비아 온담체', target: '#font-2' },
        { title: '써보기', target: '#font-sample' },
      ],
      autoState: null,
      selectedId: 0,
      activeId: 0,
      projectInfo: [
        {
          id: 0,
          name: '흘돋체',
          title: '정영훈 디자이너',
          description: '흘린 돋움이라는 뜻의 ‘흘돋’은 돋움의 골격을 갖추면서도 손 글씨의 흐름을 담아낸 돋움체입니다. 자연스러운 획의 움직임과 필기의 미감을 갖추어 읽기 편하다는 특징이 있습니다.',
          infoList: [
            {
              text: '네모 틀에 꽉 찬 자소 배치로 공간 활용이 높고, 시각 중심을 상단에 두어 편안한 글줄을 형성합니다.',
              image: 'font_project_process/heuldot/carosel-img-1.png',
            },
            {
              text: '완만하게 흘려 쓴 부드러운 흘림으로, 대부분의 꺾임을 굴림으로 표현하여 손 쓰기의 미감을 담았습니다.',
              image: 'font_project_process/heuldot/carosel-img-2.png',
            },
            {
              text: '열리고, 닫히는 속공간을 여유롭게 표현하여, 낱글자의 판독을 높였습니다.',
              image: 'font_project_process/heuldot/carosel-img-3.png',
            },
            {
              text: '손 쓰기에서 비롯하는 획 맺음을 반영하여, 삐침과 맺음의 각도는 40도~60도 사이로 했고, 이외의 획 맺음 각도는 수직과 수평으로 단정하게 했습니다.',
              image: 'font_project_process/heuldot/carosel-img-4.png',
            },
            {
              text: '획이 교차하는 부분의 뭉침을 방지하기 위해 잉크 트랩을 활용했고, 미감 측면에서도 고유한 특징을 갖도록 했습니다.',
              image: 'font_project_process/heuldot/carosel-img-5.png',
            },
          ],
        },
        {
          id: 1,
          name: '온담체',
          title: '김락현 디자이너',
          description: '가비아 온담체는 직선적인 민부리체에 손글씨의 감성을 더한 글꼴입니다. 단단하고 곧은 외곽과 글자 안쪽의 곡선들이 대비를 이루는 것이 특징입니다. 담담하게 이야기하지만 그 속에는 진한 감정이 배어 있는 듯한 인상을 주는 글꼴입니다.',
          infoList: [
            {
              text: '손글씨에서 손이 지나가는 궤적의 순서를 직관적으로 살펴볼 수 있습니다.',
              image: 'font_project_process/ondam/carosel-img-1.png',
            },
            {
              text: '손글씨의 특징에서 드러나는 이음 부분을 단순화, 직선화하였습니다.',
              image: 'font_project_process/ondam/carosel-img-2.png',
            },
            {
              text: '글자의 외곽에는 돋움의 단단함을, 내부에는 손글씨의 부드러움을 담았습니다.',
              image: 'font_project_process/ondam/carosel-img-3.png',
            },
            {
              text: '넓은 네모 틀에 꽉 찬 자소 배치로, 단단하고 평평한 글줄을 형성합니다.',
              image: 'font_project_process/ondam/carosel-img-4.png',
            },
            {
              text: '부드러움을 극대화하기 위하여 둥글린 마감을 적용하였습니다.',
              image: 'font_project_process/ondam/carosel-img-5.png',
            },
          ],
        },
      ],
      heuldotData: {
        info: {
          korean: { text: '2,780자', title: '한글자소' },
          english: { text: '52자', title: '영문자소' },
          number_spacial: { text: '721자', title: '숫자 및 기호 활자' },
          otf_size: { text: '370KB', title: 'OTF 용량' },
        },
        list: [
          { id: 0, contents: '손 쓰기에서 비롯하는 맺음의 각도', pos: { top: '38%', left: '19%' } },
          { id: 1, contents: '네모틀에 꽉찬 돋움의 골격', pos: { top: '31%', left: '40.5%' } },
          { id: 2, contents: '획 교차부분의 뭉침을 방지하는 잉크트랩', pos: { top: '36%', left: '63%' } },
          { id: 3, contents: '완만하게 흘려 쓴 부드러운 흘림', pos: { top: '67%', left: '18.5%' } },
          { id: 4, contents: '판독을 높이는 넓고, 여유로운 속공간', pos: { top: '72%', left: '85%' } },
          // { id: 5, contents: '가로쓰기 본문용 글꼴', pos: { top: '5%', left: '92%' } },
        ],
      },
      ondamData: {
        info: {
          korean: { text: '2,843자', title: '한글자소' },
          english: { text: '61자', title: '영문자소' },
          number_spacial: { text: '405자', title: '숫자 및 기호 활자' },
          otf_size: { text: '451KB', title: 'OTF 용량' },
        },
        list: [
          { id: 0, contents: '손글씨 획의 궤적', pos: { top: '18%', left: '24%' } },
          { id: 1, contents: '단순화, 직선화된 이음', pos: { top: '15%', left: '29.5%' } },
          { id: 2, contents: '외곽과 내부의 구조대비', pos: { top: '65%', left: '28%' } },
          { id: 3, contents: '평평하고 단단한 글줄', pos: { top: '32%', left: '50%' } },
          { id: 4, contents: '부드러움을 극대화한 획', pos: { top: '83.5%', left: '86.5%' } },
          // { id: 5, contents: '가로쓰기 본문용 글꼴', pos: { top: '13%', left: '92%' } },
        ],
      },
      selectPoint: -1,
      selectedFont: 'heuldot',
      selectedFontText: '흘돋체',
      editorValue: {
        fontSize: 100,
      },
      fontList: [
        { title: '흘돋체', name: 'heuldot', addText: true },
        { title: '온담체', name: 'ondam', addText: true },
      ],
      themeList: [
        { title: '밝음', name: 'light' },
        { title: '어두움', name: 'dark' },
      ],
      contenteditable: true,
    };
  },
  computed: {
    setProjectInfo() {
      return this.projectInfo[this.selectedId];
    },
    previewIndex() {
      const pIndex = this.activeId - 1;
      return pIndex < 0 ? this.setProjectInfo.infoList.length - 1 : pIndex;
    },
    nextIndex() {
      const nIndex = this.activeId + 1;
      return nIndex >= this.setProjectInfo.infoList.length ? 0 : nIndex;
    },
  },
  methods: {
    getProjectInfo(type) {
      this.activeId = 0;
      this.selectedId = type;
    },
    movePrev() {
      this.autoPlay(false);
      this.activeId = this.activeId === 0 ? this.setProjectInfo.infoList.length - 1 : this.activeId - 1;
    },
    moveNext() {
      this.autoPlay(false);
      this.activeId = this.activeId === this.setProjectInfo.infoList.length - 1 ? 0 : this.activeId + 1;
    },
    autoPlay(value) {
      if (!value) {
        clearInterval(this.autoState);
      } else {
        this.autoState = setInterval(this.moveNext, 5000);
      }
    },
    setFontFamily(font) {
      this.selectedFont = font.name;
      this.selectedFontText = font.title;
    },
    setTheme(type) {
      this.theme = type.name;
    },
    setFontSize(payload) {
      this.editorValue.fontSize = payload;
    },
  },
};
</script>

<style lang="scss" scoped>
#Font2022 {
  #font-info {
    overflow: hidden;
    background-repeat: no-repeat;
    background-position: 25% -22%, 81% 118%;
  }
  .section-contents-wrapper {
    width: 980px;
    margin: 0 auto;
    .sub-description {
      padding: 0 20px;
      margin-top: 50px;
    }
  }
  .section-contents-project-info {
    position: relative;
    margin-top: 70px;
    .project-info-type {
      position: absolute;
      display: flex;
      top: -160px;
      right: 0;
      justify-content: flex-end;
      column-gap: 14px;
      .type-font-btn {
        cursor: pointer;
        width: 270px;
        text-align: center;
        border: 1px solid #0a0a0a;
        padding: 20px;
        font-size: 22px;
        &.active_red {
          font-weight: 600;
          background-color: #FA8BA0;
        }
        &.active_green {
          font-weight: 600;
          background-color: #83EBB8;
        }
      }
    }
    .project-info-title {
      margin-bottom: 30px;
    }
    .project-info-description {
      margin-bottom: 50px;
    }
    .project-info-slide-wrapper {
      position: relative;
      .slide-nav-control {
        display: flex;
        position: absolute;
        right: 0;
        bottom: 0;
        align-items: center;
        z-index: 100;
        .prev, .next {
          cursor: pointer;
          width: 50px;
          height: 50px;
        }
        .nav-text {
          .current {
            font-weight: 600;
          }
        }
        &.red {
          svg .arrow {
            fill: #FA8BA0;
            stroke: #0a0a0a;
          }
        }
        &.green {
          svg .arrow {
            fill: #83EBB8;
            stroke: #0a0a0a;
          }
        }
      }
      .slide-wrapper{
        display: flex;
        overflow: hidden;
        position: relative;
        min-height: 478px;
        .project-info-item {
          width: 100%;
          flex-shrink: 0;
          position: absolute;
          height: 100%;
          background-color: #fff;
          transition: transform 1000ms ease;
          display: none;
          .project-image {
            height: 336px
          }
          .project-text {
            padding: 30px;
            height: 142px;
            border-top: 1px solid #0a0a0a;
          }
          &.current {
            display: block;
            z-index: 2;
            transform: translate3d(0, 0, 0);
          }
          &.prev {
            display: block;
            z-index: 1;
            transform: translate3d(-100%, 0, 0);
          }
          &.next {
            display: block;
            z-index: 1;
            transform: translate3d(100%, 0, 0);
          }
        }
      }

    }
  }
  .section-contents-editor {
    position: relative;
    width: 100%;
    height: 500px;
    background-color: #fff;
    margin-top: 100px;
    .text-editor-control {
      position: absolute;
      width: 100%;
      top: 100%;
      margin-top: 80px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      &> div {
        width: 200px;
      }
    }
    .sample-text-editor {
      position: absolute;
      width: 100%;
      max-height: 100%;
      padding: 50px;
      z-index: 100;
      font-size: 100px;
      outline: none;
      text-align: center;
      overflow-y: auto;
      color: #555555;
      &.maeumgyeol {
        font-family: 'Maeumgyeol';
      }
      &.cheongyeon {
        font-family: 'cheongyeon';
        text-align: left;
        writing-mode: vertical-rl;
      }
    }
    &.dark {
      background-color: #1f1f1f;
      .sample-text-editor {
        color: #bababa;
      }
      [contenteditable=true]:empty:before {
        content: attr(placeholder);
        display: block;
        color: #6f6f6f;
      }
    }
    [contenteditable=true]:empty:before {
      content: attr(placeholder);
      display: block;
      color: #ddd;
    }
    .content-editor-wrapper {
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 99;
      display: flex;
      align-items: center;
      justify-content: center;
      &:before {
        content: url('https://static.gabia.com/fonts/project/image/db_quotation.svg');
        position: absolute;
        top:0;
        left:0;
        transform: translate(-50%, -50%);
      }
      &:after {
        content: url('https://static.gabia.com/fonts/project/image/db_quotation.svg');
        position: absolute;
        bottom:0;
        right:0;
        transform: translate(50%, 50%) rotate(180deg);
      }
    }
  }
  .section-6 {
    margin-top: 100px;
  }
}
</style>
